window.htmlEscape = function (htmlStr) {
    return htmlStr.replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#39;");
};

window.htmlUnEscape = function (htmlStr) {
    htmlStr = htmlStr.replace(/&lt;/g , "<");
    htmlStr = htmlStr.replace(/&gt;/g , ">");
    htmlStr = htmlStr.replace(/&quot;/g , "\"");
    htmlStr = htmlStr.replace(/&#39;/g , "'");
    htmlStr = htmlStr.replace(/&amp;/g , "&");
    return htmlStr;
};

window.convertOuncesToPounds = function (ounces) {
    var pounds;
    ounces = parseFloat(ounces);
    pounds = (ounces / 16).toFixed(2); // Limit to 2 decimal places
    return pounds.toString();
};

window.convertPoundsToOunces = function (pounds) {
    var ounces;
    pounds = parseFloat(pounds);
    ounces = (pounds * 16).toFixed(2); // Limit to 2 decimal places
    return ounces.toString();
};